import React from "react";
import {
  TrendingUp,
} from "lucide-react";
import {
  StatCard,
} from "./shared";

export function OverviewTab({ stats }) {
  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs uppercase tracking-[0.22em] text-[#899480] font-semibold mb-2 flex items-center gap-2">
          <TrendingUp size={13} /> This Week
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <StatCard
            label="New Consultations"
            value={stats.consultations_last_7d}
            sub={`${stats.total_consultations} total`}
          />
          <StatCard
            label="Attend Requests"
            value={stats.attend_last_7d}
            sub={`${stats.total_attend} total`}
          />
          <StatCard
            label="Chat Leads"
            value={stats.chat_leads_last_7d}
            sub={`${stats.total_chat_leads} total`}
          />
        </div>
      </div>
      <div>
        <div className="text-xs uppercase tracking-[0.22em] text-[#899480] font-semibold mb-2">
          All Time
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          <StatCard label="Consultations" value={stats.total_consultations} />
          <StatCard label="Attend With Me" value={stats.total_attend} />
          <StatCard label="Chat Leads" value={stats.total_chat_leads} />
          <StatCard label="Newsletter" value={stats.total_newsletter} />
        </div>
      </div>
    </div>
  );
}
